import axios from "../../utils/axios";

// REACT_APP_BACKEND_URL already includes /v1.
const rolesUrl = `${process.env.REACT_APP_BACKEND_URL}/roles`;

const CACHE_DURATION = 60 * 1000;

const rolesListCache = new Map();
const roleDetailsCache = new Map();

function createListCacheKey(params = {}) {
  return JSON.stringify({
    franchiseId: params.franchiseId || "",
    page: Number(params.page) || 1,
    limit: Number(params.limit) || 10,
    name: params.name?.trim() || "",
    scope: params.scope || "",
    status: params.status || "",
    sortBy: params.sortBy || "",
  });
}

export function clearRolesCache() {
  rolesListCache.clear();
  roleDetailsCache.clear();
}

export function createRole(payload) {
  return axios.post(rolesUrl, payload).then((response) => {
    clearRolesCache();
    return response;
  });
}

export function getRoles(params, options = {}) {
  if (!params?.franchiseId) {
    return Promise.reject(new Error("Current franchise is unavailable"));
  }

  const { forceRefresh = false } = options;
  const cacheKey = createListCacheKey(params);
  const cachedRequest = rolesListCache.get(cacheKey);
  const now = Date.now();

  if (!forceRefresh && cachedRequest && cachedRequest.expiresAt > now) {
    return cachedRequest.promise;
  }

  const request = axios.get(rolesUrl, { params }).catch((error) => {
    // Do not cache failed API requests.
    rolesListCache.delete(cacheKey);
    throw error;
  });

  rolesListCache.set(cacheKey, {
    promise: request,
    expiresAt: now + CACHE_DURATION,
  });

  return request;
}

export function getRoleById(roleId, options = {}) {
  if (typeof roleId !== "string" || !roleId.trim()) {
    return Promise.reject(new Error("Invalid Role ID"));
  }

  const normalizedRoleId = roleId.trim();
  const { forceRefresh = false } = options;
  const cachedRequest = roleDetailsCache.get(normalizedRoleId);
  const now = Date.now();

  if (!forceRefresh && cachedRequest && cachedRequest.expiresAt > now) {
    return cachedRequest.promise;
  }

  const request = axios
    .get(`${rolesUrl}/${encodeURIComponent(normalizedRoleId)}`)
    .catch((error) => {
      roleDetailsCache.delete(normalizedRoleId);
      throw error;
    });

  roleDetailsCache.set(normalizedRoleId, {
    promise: request,
    expiresAt: now + CACHE_DURATION,
  });

  return request;
}

export function updateRole(roleId, payload) {
  if (typeof roleId !== "string" || !roleId.trim()) {
    return Promise.reject(new Error("Invalid Role ID"));
  }

  const normalizedRoleId = roleId.trim();

  return axios
    .patch(`${rolesUrl}/${encodeURIComponent(normalizedRoleId)}`, payload)
    .then((response) => {
      clearRolesCache();
      return response;
    });
}
